import { zIndex } from 'constants/index';
import React, { useRef } from 'react';
import { Box } from '@landr/maestro';
import styled from 'styled-components';
import { useSearchBarContext } from 'components/Filters/context/SearchBarContext/SearchBarContext';
import Suggestions from './components/Suggestions/Suggestions';
import FiltersAndInput from './components/FiltersAndInput/FiltersAndInput';

const CaptureClickOutside = styled(Box)`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: transparent;
`;

const _SearchBar = ({
    suggestionRef,
    isModal,
    isSuggestionsOpen,
    closeSuggestions,
    hasSuggestions,
}: {
    suggestionRef: React.RefObject<HTMLDivElement>;
    isModal: boolean;
    isSuggestionsOpen: boolean;
    closeSuggestions: () => void;
    hasSuggestions: boolean;
}) => (
    <>
        {!isModal && isSuggestionsOpen && (
            <CaptureClickOutside onClick={closeSuggestions} />
        )}
        <FiltersAndInput
            triggerRef={suggestionRef}
            isModal={isModal}
            isSuggestionsOpen={isSuggestionsOpen}
            hasSuggestions={hasSuggestions}
        />
        <Suggestions anchorRef={suggestionRef} isModal={isModal} />
    </>
);

const SearchBar = () => {
    const ref = useRef<HTMLDivElement>(null);
    const {
        isSuggestionsOpen,
        closeSuggestions,
        hasSuggestions,
        handleKeyPress,
        isModal,
    } = useSearchBarContext();

    return (
        <Box
            onKeyDown={handleKeyPress}
            zIndex={zIndex.searchBar}
            position="relative"
        >
            <_SearchBar
                suggestionRef={ref}
                isModal={isModal}
                isSuggestionsOpen={isSuggestionsOpen}
                closeSuggestions={closeSuggestions}
                hasSuggestions={hasSuggestions}
            />
        </Box>
    );
};

SearchBar.displayName = 'Filters.SearchBar';

export default SearchBar;
